import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, LinearProgress } from "@material-ui/core";
import { Booking } from "api/bookings";
import { useSnackbar } from "notistack";
import { GridTextField } from "components";
import { postBookingRequestCancellation } from "api/admin/bookings";
import i18n from "../i18n";

// prop types
interface RequestCancellationDialogProps {
    booking?: Booking,
    show: boolean,
    onClose: () => void,
    onFetchBookings: () => void,
}

// request cancellation dialog
const RequestCancellationDialog = ({ booking, show, onClose, onFetchBookings }: RequestCancellationDialogProps) => {
    // snackbar
    const { enqueueSnackbar } = useSnackbar();
    const displayError = (error: any) => enqueueSnackbar(
        `${i18n.anErrorOccurred}: ${error.description} (${error.type})`,
        { variant: "error" },
    );

    // ui state
    const [isLoading, setLoading] = useState(false);
    const [reason, setReason] = useState("");

    // reset ui
    useEffect(() => { if (!show) setReason(""); }, [show]);

    // api request
    const cancelAction = async () => {
        setLoading(true);
        try {
            await postBookingRequestCancellation({
                bookingId: booking!.id,
                reason,
            });
            onFetchBookings();
            onClose();
        } catch (error) {
            displayError(error);
        }
        setLoading(false);
    };

    // render
    return (
        <Dialog
            fullWidth
            open={show}
            onClose={onClose}
        >
            <DialogTitle>{i18n.requestCancellation}</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <GridTextField
                        helperText={i18n.cancellationReasonLength}
                        label={i18n.cancellationReason}
                        maxLength={100}
                        size={12}
                        value={reason}
                        onChange={setReason}
                    />
                </Grid>
            </DialogContent>
            {isLoading && <LinearProgress />}
            <DialogActions>
                <Button color="secondary" onClick={onClose}>
                    {i18n.cancel}
                </Button>
                <Button color="primary" disabled={isLoading || reason.length < 4} onClick={cancelAction}>
                    {i18n.cancelB}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RequestCancellationDialog;
